import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PERMISSION_MODULES } from '@/shared/const'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PathCard } from '@/shared/ui/path-card'
import { PermissionGuard } from '@/shared/ui/permission-guard'

export const Route = createFileRoute('/_auth/journal/')({
  staticData: {
    meta: {
      title: 'Журнал действий',
      description: '',
    },
  },
  component: RouteComponent,
})
function RouteComponent() {
  const { t } = useTranslation()
  return (
    <PermissionGuard permission={PERMISSION_MODULES.ADMINISTRATION}>
      <PageWrapper title={t('Журнал действий')}>
        <PathCard path="/journal/tabs/auth" title={t('Авторизация')} />
        <PathCard path="/journal/tabs/users" title={t('Пользователи и роли')} />
      </PageWrapper>
    </PermissionGuard>
  )
}
